<template>
    <div v-if="showSuccess">
        <slot name="thankyou" :bind="this"></slot>
    </div>
    <div v-else>
        <slot name="form-forgot-account" v-bind="this"></slot>
    </div>
</template>

<script>
import FormValidator from "lib/form-validator.mjs";
    export default {
        props: {
            target: {
                type: String,
                required: true
            },
            csrf: {
                type: String,
                required: true
            },
            redirect: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                email: '',
                showErrorEmail: false,
                errorMessageEmail: '',
                formValidator: new FormValidator({
                    email: {
                        required: true,
                        type: 'email_or_phone',
                    },
                }, {
                    email: '',
                }),
                errors: {
                    email: { init: 1 },
                },
                generalError:false,
                submitLock: true,
                showSuccess: false,
            }
        },
        watch: {
            email(val) {
                this.hideError('email');
                this.formValidator.setValue('email', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('email', error );
                        this.evaluateButtonStatus();
                    }
                );
            },
        },
        methods: {
            hideError( name ){
                this.errors[ name ] = {};
            },
            showError( name, error ){
                this.errors[ name ] = {};
                this.errors[ name ][ error ] = true;
            },
            evaluateButtonStatus(){
                for( let error in this.errors ){
                    if( Object.keys( this.errors[ error ] ).length > 0 ){
                        this.submitLock = true;
                        return;
                    }
                }
                this.submitLock = false;
            },
            validateInput(field) {
                if(field === 'email') {
                    if(!this.email) {
                        this.showErrorEmail = true;
                        this.errorMessageEmail = this.textEmailError;
                    } else {
                        this.showErrorEmail = false;
                        this.errorMessageEmail = '';
                    }
                }
            },

            handleForgotAccount(e) {
                e.preventDefault();


                this.validateInput('email');

                if(this.showErrorEmail) return;
            },

            removeInvalidClass(e) {
                e.target.classList.remove('is-invalid');
            },

            getPayload() {
                return {
                    email: this.email
                }
            },
            submit(){
                const valid = this.formValidator.isValid();
                if( valid ) {
                    this.send();
                }
            },
            send(){
                const payload = this.getPayload();
                this.generalError = false;
                this.submitLock = true;
                this.$emit( 'wait', true );
                fetch( this.target, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.csrf
                    },
                    body: JSON.stringify( payload )
                }).then( response => {
                    this.$emit( 'wait', false );
                    if( response.status === 200 ){
                        this.showSuccess = true;
                        this.$emit( 'success' );
                    } else {
                        this.generalError = true;
                        this.$emit( 'error' );
                    }
                }).catch( error => {
                    this.$emit( 'wait', false );
                    this.generalError = true;
                    this.$emit( 'error' );
                });
            }

        }
    }
</script>
